import React from 'react'
import ErrorPage from './ErrorPage'

const CrashPage = ( {handleRetry} ) => {

    return (
        <ErrorPage
            errorStatus = {500}
            errorMessage = "Couldn't load your notes."
            errorDesc = "Our server ran into an unexpected problem while trying to retrieve your notes. This is on us — your notes are safe. Please try again in a moment."
            handleRetry = {()=>handleRetry()}
        />
    )
}

export default CrashPage